import React, { useEffect, useState } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { injectIntl } from '../../util/reactIntl';
import { parse } from '../../util/urlHelpers';
import routeConfiguration from '../../routeConfiguration';
import { createResourceLocatorString } from '../../util/routes';
import {
  DatePicker,
  LayoutSideNavigation,
  LayoutWrapperMain,
  LayoutWrapperBusinessSideNav,
  LayoutWrapperTopbar,
  LayoutWrapperFooter,
  Footer,
  Page,
  UserNav,
  BusinessSummary,
  BusinessTable,
  Select,
  AutocompleteSelect
} from '../../components';
import { TopbarContainer } from '../../containers';

import { isScrollingDisabled } from '../../ducks/UI.duck';
import css from './BusinessResultsPage.css';

const date = new Date();
const currentYear = date.getFullYear();
const currentMonth = date.getMonth();
const firstDay = new Date(currentYear, currentMonth, 2).toISOString().split('T')[0];
const lastDay = new Date().toISOString().split('T')[0];

export const BusinessResultsPageComponent = props => {
  const {
    scrollingDisabled,
    intl,
    location,
    history,
    onLoadData,
    currentUserProviders
  } = props;

  const { start = firstDay, end = lastDay, prev_start, prev_end, groupingDate = 'deliveredAt', providerId } = parse(location.search);
  const isComparisonOn = prev_start && prev_end;
  const [data, setData] = useState(null);
  const [prevData, setPrevData] = useState(null);
  const [additionalData, setAdditionalData] = useState(null);
  const [prevAdditionalData, setPrevAdditionalData] = useState(null);
  const [additional2Data, setAdditional2Data] = useState(null);
  const [prevAdditional2Data, setPrevAdditional2Data] = useState(null);
  const [error, setError] = useState(null);

  const selectedProvider = currentUserProviders.find(p => p.id.uuid === providerId);

  useEffect(() => {
    selectedProvider && onLoadData({ [`${groupingDate}GreaterThan`]: start, [`${groupingDate}LessThan`]: end, currency: selectedProvider.attributes.currency, providerId, businessCategory: '*' }).then(res => setData(res.data));
    selectedProvider && prev_start && prev_end && onLoadData({ [`${groupingDate}GreaterThan`]: prev_start, [`${groupingDate}LessThan`]: prev_end, currency: selectedProvider.attributes.currency, providerId, businessCategory: '*' }).then(res => setPrevData(res.data));

    selectedProvider && onLoadData({ [`${groupingDate}GreaterThan`]: start, [`${groupingDate}LessThan`]: end, currency: selectedProvider.attributes.currency, providerId, listingId: '*', include: ['listing'] }).then(res => setAdditionalData(res.data));
    selectedProvider && prev_start && prev_end && onLoadData({ [`${groupingDate}GreaterThan`]: prev_start, [`${groupingDate}LessThan`]: prev_end, currency: selectedProvider.attributes.currency, providerId, listingId: '*', include: ['listing'] }).then(res => setPrevAdditionalData(res.data));

    selectedProvider && selectedProvider.attributes.deliveryToHome && onLoadData({ [`${groupingDate}GreaterThan`]: start, [`${groupingDate}LessThan`]: end, currency: selectedProvider.attributes.currency, providerId, deliveryLocation: '*', include: ['deliveryToProvider'] }).then(res => setAdditional2Data(res.data));
    selectedProvider && selectedProvider.attributes.deliveryToHome && prev_start && prev_end && onLoadData({ [`${groupingDate}GreaterThan`]: prev_start, [`${groupingDate}LessThan`]: prev_end, currency: selectedProvider.attributes.currency, providerId, deliveryLocation: '*', include: ['deliveryToProvider'] }).then(res => setPrevAdditional2Data(res.data));
  }, [start, end, selectedProvider, groupingDate, prev_start, prev_end])

  const title = intl.formatMessage({id: "BusinessResultsPage.title"});

  const handleDateRangeSubmit = ({ start, end, prevStart, prevEnd }) => {
    const prevDates = prevStart && prevEnd ? { prev_start: prevStart, prev_end: prevEnd } : {};

    history.push(
      createResourceLocatorString(
        'BusinessResultsPage',
        routeConfiguration(),
        {},
        { start, end, providerId, groupingDate, ...prevDates }
      )
    );
  }

  const handleProviderChange = (option) => {
    const providerUuid = option?.value;

    if (!providerUuid) return;
    history.push(
      createResourceLocatorString(
        'BusinessResultsPage',
        routeConfiguration(),
        {},
        { start, end, providerId: providerUuid, groupingDate, prev_start, prev_end }
      )
    );
  }

  const handleGroupingDateChange = (e) => {
    history.push(
      createResourceLocatorString(
        'BusinessResultsPage',
        routeConfiguration(),
        {},
        { groupingDate: e.target.value, start, end, providerId, prev_start, prev_end  }
      )
    );
  }

  const concatenatedData = data ? data.data.slice(1).map(provider => {
    const providerPrevData = prevData?.data ? prevData.data.find(i => i.id.uuid !== 'all' && i.attributes.businessCategory === provider.attributes.businessCategory) : null;

    return {
      label: provider.attributes.businessCategory || 'other',
      // providerId: providerData.id.uuid,
      providerName: provider.attributes.businessCategory,
      data: [
        { current: provider ? (provider.attributes.incomeTotal / 100).toFixed(2) : 0, prev: providerPrevData ? (providerPrevData.attributes.incomeTotal / 100).toFixed(2) : 0  },
        { current: provider ? provider.attributes.itemsCount : 0, prev: providerPrevData ? providerPrevData.attributes.itemsCount : 0 },
        { current: provider ? ((provider.attributes.incomeTotal / provider.attributes.itemsCount) / 100).toFixed(2) : 0, prev: providerPrevData ? ((providerPrevData.attributes.incomeTotal / providerPrevData.attributes.itemsCount) / 100).toFixed(2) : 0 },
        // { current: provider ? (provider.attributes.incomeMax / 100).toFixed(2) : 0 },
        { current: provider ? (provider.attributes.avgDuration * 1).toFixed(1) : 0, prev: providerPrevData ? (providerPrevData.attributes.avgDuration * 1).toFixed(1) : 0 }
      ],
    }
  }) : [];

  const concatenatedAdditionalData = additionalData ? additionalData.data.slice(1).map(listing => {
    const listingData = additionalData.included.find(i => i.id.uuid === listing.relationships.listing.data.id.uuid);
    const prevListing = prevAdditionalData?.data ? prevAdditionalData.data.slice(1).find(i => i.relationships.listing.data.id.uuid === listing.relationships.listing.data.id.uuid) : null;

    return {
      label: listingData.attributes.title,
      // providerId: providerData.id.uuid,
      data: [
        { current: listing ? (listing.attributes.incomeTotal / 100).toFixed(2) : 0, prev: prevListing ? (prevListing.attributes.incomeTotal / 100).toFixed(2) : 0 },
        { current: listing ? listing.attributes.itemsCount : 0, prev: prevListing ? prevListing.attributes.itemsCount : 0 },
        { current: listing ? ((listing.attributes.incomeTotal / listing.attributes.itemsCount)  / 100).toFixed(2) : 0, prev: prevListing ? ((prevListing.attributes.incomeTotal / prevListing.attributes.itemsCount)  / 100).toFixed(2) : 0  },
        // { current: listing ? (listing.attributes.incomeMax / 100).toFixed(2) : 0 },
        { current: listing ? (listing.attributes.avgDuration * 1).toFixed(1) : 0, prev: prevListing ? (prevListing.attributes.avgDuration * 1).toFixed(1) : 0 }
      ],
    }
  }) : [];

  const concatenatedAdditional2Data = additional2Data ? additional2Data.data.slice(1).map(loc => {
    const deliveryProviderData = additional2Data.included.find(i => loc.attributes.deliveryLocation === 'store' && i.id.uuid === loc.relationships.deliveryToProvider.data.id.uuid);
    const prevLoc = prevAdditional2Data?.data ? prevAdditional2Data.data.slice(1).find(i => i.relationships.deliveryToProvider.data?.id?.uuid === loc.relationships.deliveryToProvider.data?.id?.uuid) : null;

    return {
      label: deliveryProviderData ? deliveryProviderData.attributes.name : intl.formatMessage({id: "BusinessResultsPage.homeDelivery"}),
      // providerId: providerData.id.uuid,
      data: [
        { current: loc ? (loc.attributes.incomeTotal / 100).toFixed(2) : 0, prev: prevLoc ? (prevLoc.attributes.incomeTotal / 100).toFixed(2) : 0 },
        { current: loc ? loc.attributes.transactionsCount : 0, prev: prevLoc ? prevLoc.attributes.transactionsCount : 0 },
        { current: loc ? loc.attributes.itemsCount : 0, prev: prevLoc ? prevLoc.attributes.itemsCount : 0 },
        { current: loc ? ((loc.attributes.incomeTotal / loc.attributes.transactionsCount) / 100).toFixed(2) : 0, prev: prevLoc ? ((prevLoc.attributes.incomeTotal / prevLoc.attributes.transactionsCount) / 100).toFixed(2) : 0 },
        // { current: loc ? (loc.attributes.incomeMax / 100).toFixed(2) : 0 },
        { current: loc ? (loc.attributes.avgDuration * 1).toFixed(1) : 0, prev: prevLoc ? (prevLoc.attributes.avgDuration * 1).toFixed(1) : 0 }
      ],
    }
  }) : [];

  const turnoverMsg = intl.formatMessage({ id: 'BusinessResults.turnover' });
  const quantityMsg = intl.formatMessage({ id: 'BusinessResults.quantity' });
  const rentingsMsg = intl.formatMessage({ id: 'BusinessResults.rentings' });
  const avgRentingMsg = intl.formatMessage({ id: 'BusinessResults.avgRentingValue' });
  const maxRentingMsg = intl.formatMessage({ id: 'BusinessResults.maxRentingValue' });
  const avgRentingLengthMsg = intl.formatMessage({ id: 'BusinessResults.avgRentingLength' });
  const daysMsg = intl.formatMessage({ id: 'BusinessResults.days' });
  const numberMsg = intl.formatMessage({ id: 'BusinessResults.count' });

  return (
    <Page title={title} scrollingDisabled={scrollingDisabled}>
      <LayoutSideNavigation>
        <LayoutWrapperTopbar>
          <TopbarContainer
            currentPage="BusinessResultsPage"
            desktopClassName={css.desktopTopbar}
            mobileClassName={css.mobileTopbar}
          />
          <UserNav selectedPageName="BusinessResultsPage" />
        </LayoutWrapperTopbar>
        <LayoutWrapperBusinessSideNav currentTab="BusinessResultsPage" />
        <LayoutWrapperMain className={css.colorBackground}>
          <div className={css.content}>
            <div className={css.header}>
              <h1 className={css.title}>
                {intl.formatMessage({ id: 'BusinessResults.header' })}
              </h1>
              <DatePicker onSubmit={handleDateRangeSubmit} value={{ startDate: start, endDate: end, prevStartDate: prev_start, prevEndDate: prev_end }} showComparison={true} />
            </div>
            <div className={css.filters}>
              <AutocompleteSelect
                label={intl.formatMessage({ id: 'BusinessResults.providerField' })}
                inputValue={{
                  value: providerId,
                  label: currentUserProviders.find(p => p.id.uuid === providerId)?.attributes.name || intl.formatMessage({ id: 'BusinessResults.providerField' })
                }}
                onChange={handleProviderChange}
                options={currentUserProviders.map(provider => ({
                  value: provider.id.uuid,
                  label: provider.attributes.name
                }))}
              />
              <Select
                label={intl.formatMessage({ id: 'BusinessDktPage.filtering' })}
                value={groupingDate}
                onChange={handleGroupingDateChange}
              >
                <option value="createdAt">{intl.formatMessage({ id: 'BusinessDktPage.createdAt' })}</option>
                <option value="deliveredAt">{intl.formatMessage({ id: 'BusinessDktPage.deliveredAt' })}</option>
              </Select>
            </div>
            {
              data &&
              <BusinessSummary
                currency={selectedProvider.attributes.currency}
                currentData={{
                  payinTotal: data.data[0].attributes.incomeTotal,
                  transactionsCount: data.data[0].attributes.transactionsCount,
                  payoutTotal: data.data[0].attributes.payoutTotal,
                  payinAvg: data.data[0].attributes.incomeAvg,
                  payinMax: data.data[0].attributes.incomeMax,
                  avgDuration: data.data[0].attributes.avgDuration,
                  itemsCount: data.data[0].attributes.itemsCount
                }}
                previousData= {prevData && {
                  payinTotal: prevData.data[0].attributes.incomeTotal,
                  transactionsCount: prevData.data[0].attributes.transactionsCount,
                  payoutTotal: prevData.data[0].attributes.payoutTotal,
                  payinAvg: prevData.data[0].attributes.incomeAvg,
                  payinMax: prevData.data[0].attributes.incomeMax,
                  avgDuration: prevData.data[0].attributes.avgDuration,
                  itemsCount: prevData.data[0].attributes.itemsCount,
                }}
              />
            }
            {
              data &&
              <BusinessTable
                rows={concatenatedData}
                isComparisonOn={isComparisonOn}
                sortBy={0}
                firstRowName={intl.formatMessage({ id: 'General.category' })}
                dataHeaders={[
                  { primary: turnoverMsg, secondary: `(${selectedProvider.attributes.currency})` },
                  { primary: quantityMsg, secondary: `(${numberMsg})` },
                  { primary: avgRentingMsg, secondary: `(${selectedProvider.attributes.currency})` },
                  // { primary: maxRentingMsg, secondary: `(${selectedProvider.attributes.currency})` },
                  { primary: avgRentingLengthMsg, secondary: `(${daysMsg})` }
                ]}
                dates={{ firstDay, lastDay }}
                extendableRows={false}
              />
            }
            {
              additionalData &&
              <BusinessTable
                rows={concatenatedAdditionalData}
                isComparisonOn={isComparisonOn}
                sortBy={0}
                firstRowName={intl.formatMessage({ id: 'BusinessResults.product' })}
                dataHeaders={[
                  { primary: turnoverMsg, secondary: `(${selectedProvider.attributes.currency})` },
                  { primary: quantityMsg, secondary: `(${numberMsg})` },
                  { primary: avgRentingMsg, secondary: `(${selectedProvider.attributes.currency})` },
                  // { primary: maxRentingMsg, secondary: `(${selectedProvider.attributes.currency})` },
                  { primary: avgRentingLengthMsg, secondary: `(${daysMsg})` }
                ]}
                dates={{ firstDay, lastDay }}
                extendableRows={false}
              />
            }
            {
              additional2Data && ( selectedProvider.attributes.deliveryToHome || !!selectedProvider?.deliveryToProviders.length) &&
              <BusinessTable
                rows={concatenatedAdditional2Data}
                isComparisonOn={isComparisonOn}
                sortBy={0}
                firstRowName={intl.formatMessage({ id: 'BusinessResults.location' })}
                dataHeaders={[
                  { primary: turnoverMsg, secondary: `(${selectedProvider.attributes.currency})` },
                  { primary: rentingsMsg, secondary: `(${numberMsg})` },
                  { primary: 'Produkty', secondary: `(${numberMsg})` },
                  { primary: avgRentingMsg, secondary: `(${selectedProvider.attributes.currency})` },
                  // { primary: maxRentingMsg, secondary: `(${selectedProvider.attributes.currency})` },
                  { primary: avgRentingLengthMsg, secondary: `(${daysMsg})` }
                ]}
                dates={{ firstDay, lastDay }}
                extendableRows={false}
              />
            }
          </div>
        </LayoutWrapperMain>
        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSideNavigation>
    </Page>
  );
};

const mapStateToProps = state => {
  // Topbar needs user info.
  const { currentUser, userProviders: currentUserProviders } = state.user;
  return {
    currentUser,
    currentUserProviders,
    scrollingDisabled: isScrollingDisabled(state),
  };
};

const loadData = params => (dispatch, getState, sdk) => {
  return sdk.newSdk.analyticsBookings.query({ ...params })
    .then((res) => {
      return res;
    })
    .catch(e => {
      console.error(e, 'initial-message-send-failed', { tx: 'PLN' });
    });
};

const mapDispatchToProps = dispatch => ({
  onLoadData: (params) => dispatch(loadData(params))
});

const BusinessResultsPage = compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  injectIntl,
  withRouter
)(BusinessResultsPageComponent);

export default BusinessResultsPage;
